import LaunchIcon from '@mui/icons-material/Launch';
import { Badge, Button, Divider, Stack, Tab, Tabs, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import {
  ADMIN_CONTRACTS_URL,
  ALERTS_URL,
  CLIENTS_LIST_URL,
  CUSTOM_SEGMENTS_LIST_URL,
  PIXEL_GENERATOR_URL,
  PREVIEW_STUDIO_URL,
  REPORTING_HUB_URL,
  SHARED_APP_LIST_URL
} from '../../constants/routeUrls';
import { TOP_NAVIGATION_HEIGHT } from '../../constants/style';
import { useAuth } from '../../hooks/useAuth';
import { useOpenAlertsCount } from '../../hooks/useBoard';
import { useConfig } from '../../hooks/useConfig';
import HeaderSearch from './HeaderSearch';

const subNavList = [
  {
    to: ADMIN_CONTRACTS_URL,
    label: 'Contract List',
    value: 'contract',
  },
  {
    to: ALERTS_URL,
    label: 'Alerts',
    value: 'alerts',
  },
  {
    to: CLIENTS_LIST_URL,
    label: 'Clients',
    value: 'clients',
  },
  {
    to: CUSTOM_SEGMENTS_LIST_URL,
    label: 'Custom Segments',
    value: 'customSegments',
  },
  {
    to: SHARED_APP_LIST_URL,
    label: 'Shared App Lists',
    value: 'sharedAppLists',
  },
  {
    to: PIXEL_GENERATOR_URL,
    label: 'Pixel Generator',
    value: 'pixelGenerator',
  },
  {
    to: REPORTING_HUB_URL,
    label: 'Reporting Hub',
    value: undefined,
    hide: true,
  }
];

function SubNav() {
  const { pathname } = useLocation();
  const theme = useTheme();
  const { apiHost } = useConfig();
  const { user } = useAuth();
  const openAlertsCount = useOpenAlertsCount(user?.email);

  const [activeTab, setActiveTab] = useState({ to: undefined, label: undefined, value: undefined});

  useEffect(() => {
    setActiveTab(subNavList.find((item) => pathname.startsWith(item.to)));
  }, [pathname]);

  // eslint-disable-next-line @typescript-eslint/dot-notation
  const mainNavHeight = theme?.mixins?.toolbar?.['@media (min-width:600px)']?.['minHeight'] || TOP_NAVIGATION_HEIGHT;

  return (
    <Stack>
      <Stack direction="row" pl={2} py={2} pr={0} sx={{ minHeight: '32px' }} justifyContent="space-between">
        <Typography variant="h4" id="header-title">
          {activeTab?.label}
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <HeaderSearch />
          <Stack id="header-extra" />
        </Stack>
      </Stack>
      <Stack
        sx={{
          background: '#F9F9F9',
          zIndex: 2,
          position: 'sticky',
          top: import.meta.env.VITE_IS_FEDERATED ? mainNavHeight : 0,
        }}
      >
        <Stack flexGrow={1} position="sticky" mx={2}>
          <Stack flexGrow={1} alignItems="center" direction="row" spacing={3}>
            <Tabs value={activeTab?.value || subNavList[0].value} aria-label="basic tabs example" variant="scrollable">
              {subNavList.filter(item => !item.hide).map(
                (item) =>
                  (item.value !== 'pixelGenerator' || apiHost.includes('-qa') || apiHost.includes('localhost')) && (
                    <Tab
                      key={item.to}
                      sx={{ minWidth: '150px', textTransform: 'none' }}
                      component={RouterLink}
                      to={item.to}
                      label={
                        item.value === 'alerts' && openAlertsCount > 0 ? (
                          <Badge color="error" badgeContent={openAlertsCount} sx={{ pr: 1.5 }}>
                            {item.label}
                          </Badge>
                        ) : (
                          item.label
                        )
                      }
                      value={item.value}
                    />
                  )
              )}
            </Tabs>
            <Button
              variant="outlined"
              component={RouterLink}
              to={PREVIEW_STUDIO_URL}
              endIcon={<LaunchIcon />}
              size="small"
            >
              Preview Studio
            </Button>
          </Stack>
        </Stack>
        <Divider />
      </Stack>
    </Stack>
  );
}

export default SubNav;
